import { useMemo } from "react";
import { Box } from "@mui/material";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PageTitle from "../../../components/common/PageTitle/PageTitle";
import { useServiceModuleById } from "../../../store/selectors/serviceModulesSelector";
import AbsenceOverviewPage from "./AbsenceOverviewPage";

const AbsenceModulePage = () => {
  const { t } = useTranslation();
  const { serviceModuleId } = useParams<{ serviceModuleId: string }>();
  const parsedServiceModuleId = Number(serviceModuleId);
  const lookupServiceModuleId = Number.isFinite(parsedServiceModuleId)
    ? parsedServiceModuleId
    : -1;
  const serviceModule = useServiceModuleById(lookupServiceModuleId);

  const pageTitle = useMemo(
    () =>
      serviceModule?.name ??
      t("serviceModulesPage.absencePage.title"),
    [serviceModule?.name, t]
  );

  const breadcrumbs = useMemo(() => {
    const crumbs = [
      {
        title: "serviceModulesPage.serviceModules",
        link: "serviceModules",
      },
    ];

    if (serviceModuleId) {
      crumbs.push({
        title: pageTitle,
        link: `serviceModules/absence/${serviceModuleId}`,
      });
    }

    return crumbs;
  }, [pageTitle, serviceModuleId]);

  return (
    <>
      <PageTitle breadcrumbs={breadcrumbs} title={pageTitle} />
      <Box sx={{ mt: 3 }}>
        <AbsenceOverviewPage />
      </Box>
    </>
  );
};

export default AbsenceModulePage;
